import { render, staticRenderFns } from "./exbmain.vue?vue&type=template&id=6db40ce5&scoped=true"
import script from "./exbmain.vue?vue&type=script&lang=js"
export * from "./exbmain.vue?vue&type=script&lang=js"
import style0 from "./exbmain.vue?vue&type=style&index=0&id=6db40ce5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db40ce5",
  null
  
)

export default component.exports